module.exports = __webpack_public_path__ + "static/img/96020B_1_R_20201021_fit.21213ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/96020B_1_R_20201021_fit.png
// module id = /VJP
// module chunks = 0